import EvidenceTextCard from "../../atoms/EvidenceTextCard"
import style from "./index.module.scss"

export default function EvidenceTextList(props) {
  const { aData, gap, ...oRest } = props

  if (!aData?.length) return null

  const marginCards = gap ? gap : "32px"
  return (
    <div className={style.evidenceListContainer}>
      <ul
        className={style.evidenceListCard}
        style={{ gap: `${marginCards}px` }}
      >
        {aData.map((oData, i) => {
          return (
            <li key={i}>
              <EvidenceTextCard oData={oData} {...oRest} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
